import { useState, useEffect } from 'react';

export default function usePerformanceTiming() {
  const [performanceTiming, setPerformanceTiming] = useState({
    timeToFirstByte: undefined,
    timeToFirstRender: undefined,
  });

  useEffect(() => {
    if (!window.performance || !window.performance.timing) {
      return;
    }
    const now = new Date().getTime();
    const { requestStart, responseStart } = window.performance.timing;
    setPerformanceTiming({
      timeToFirstByte: responseStart - requestStart,
      timeToFirstRender: now - requestStart,
    });
  }, []);

  return performanceTiming;
}
